// extracted by mini-css-extract-plugin
export default {"body":"dashboard_body__lIhRH","content":"dashboard_content__8Ig4g","right_side":"dashboard_right_side__86tR0","right_side_full":"dashboard_right_side_full__wVSL3"};